import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from "moment";
import "moment/locale/pt-br";
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
// import moment from "moment";
// import "moment/locale/pt-br";
// moment.locale("pt-br");

import './Events.scss'

const columns = [
    { id: 'Evento', label: 'Evento', minWidth: 100 },
    { id: 'Data', label: 'Data', minWidth: 100 },
    // { id: 'Visitas', label: 'Visitas', minWidth: 100 },
    // { id: 'Inscricoes', label: 'Inscrições', minWidth: 100 },
    // { id: 'Acessos', label: 'Acessos', minWidth: 100 },
];

function createData( Evento, Data, Visitas, Inscricoes, Acessos) {
    return { Evento, Data, Visitas, Inscricoes, Acessos };
}

function isOdd(n) {
    return Math.abs(n % 2) == 1;
}

const useStyles = makeStyles({
    root: {
        width: '100%',

        "& .MuiTableCell-head": {
            color: "#000000",
            backgroundColor: "white",
            fontSize: 16,
            fontWeight: 'bold',
        },
    
        "& .MuiTableCell-body": {
            color: "#000000",
            fontSize: 16,
        },
        "& .table-title": {
            color: "#303030",
            fontSize: 26,
        },
    },
    container: {
        maxHeight: 586,
        marginTop: 30
    },
    
});


function Events({events}){

    const classes = useStyles();
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if ( events?.length > 0 ) {
            buildRows();
        }
        return () => {}

    }, [events]);
    
    function buildRows() {
        let rows = []
        events.map(event => {
            rows.push(
                createData(event.title, moment(event.dateStart).format("ll"), '', '', 0 )
            )
        })
        setRows(rows);
    }

    return (
        <Paper className={classes.root} style={{boxShadow: "none"}} >
            <label className='table-title'> Informações dos eventos </label>
            <TableContainer className={classes.container}>
                <Table stickyHeader>
                    <TableHead >
                        <TableRow>
                        {columns.map((column) => (
                            <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth, borderBottom:"none" }}
                            >
                            {column.label}
                            </TableCell>
                        ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => { */}
                        {rows.map((row, index) => {
                        return (
                            <TableRow 
                                hover 
                                role="checkbox" 
                                tabIndex={-1} 
                                key={row.code}
                                style={{ background: isOdd(index) ? '#FFFFFF' : '#F8F9FF'}}
                            >
                            {columns.map((column) => {
                                return (
                                <TableCell style={{borderBottom:"none"}} key={column.id} align={column.align}>
                                    {row[column.id]}
                                </TableCell>
                                );
                            })}
                            </TableRow>
                        );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

export default Events;